import { config } from '../config.js';
import { checkTauriPresentSync } from '../services/backend/isDesktop';

/**
 * Application runtime mode.
 *
 * The 2x2 matrix:
 *   - Platform: 'desktop' (Tauri) or 'browser'
 *   - Connectivity: 'standalone' (local-only), 'connected-local' (intranet),
 *     or 'connected-cloud' (full online, default for browser)
 *
 * Feature flags derived from the mode:
 *   - isOnline: whether sync/member features should be shown
 *   - isDesktop: whether device-related features should be shown
 *   - canSync: whether the sync button + dirty status should be visible
 *   - canManageMembers: whether members modal/invite should be visible
 *   - canShowFileDiff: whether to color-code files by sync status
 *
 * Modes:
 *   - 'standalone': desktop only, no remote, no auth required (DatLab9 standalone)
 *   - 'connected-local': desktop + intranet Gitea/Keycloak (DatLab9 multi-user)
 *   - 'connected-cloud': browser or desktop + cloud-hosted (DatLabStudio)
 *
 * Configuration:
 *   - VITE_APP_MODE env var overrides auto-detection
 *   - Default: browser → 'connected-cloud', desktop → 'standalone'
 */
export function useAppMode() {
  const isDesktop = checkTauriPresentSync();
  const envMode = config.appMode;

  // Auto-detect default if no env override
  const mode = envMode || (isDesktop ? 'standalone' : 'connected-cloud');

  const isOnline = mode === 'connected-local' || mode === 'connected-cloud';
  const isStandalone = mode === 'standalone';

  return {
    mode,
    isDesktop,
    isOnline,
    isStandalone,
    // Feature flags
    canSync: isOnline,
    canManageMembers: isOnline,
    canShowFileDiff: isOnline,
    canShowDirtyBadge: isOnline,
    requiresLogin: isOnline,
  };
}
